module.exports = __webpack_public_path__ + "4b7cffb023be3604950c94d893fb5e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-320.jpg
// module id = 211
// module chunks = 0